const components = [{
  el: 'header',
  fileName: 'core/header'
}, {
  el: '[data-src]',
  fileName: 'components/lazyLoader'
}, {
  el: '[data-toggle="modal"]',
  fileName: 'components/video-modal'
}, {
  el: '.accordion',
  fileName: 'plugins/accordion'
}, {
  el: 'select',
  fileName: 'components/select'
}, {
  el: '.tabs',
  fileName: 'components/tabs'
}, {
  el: '.ce-tabs',
  fileName: 'components/tab-slider'
}, {
  el: '.ce-tabs_with_background',
  fileName: 'components/tabs-with-background'
}, {
  el: '.ce_text_with_background__slider',
  fileName: 'components/text-with-background'
}, {
  el: '.slider-navigation',
  fileName: 'components/inpage-navigation'
}, {
  el: '.scroll-shadow, .scroll-shadow__content',
  fileName: 'components/scroll-shadow'
}, {
  el: '.dropdown',
  fileName: 'plugins/dropdown'
}, {
  el: '.form-range',
  fileName: 'plugins/range-slider'
}, {
  el: '.solr-search',
  fileName: 'components/search'
}, {
  el: '.page-content .solr-search',
  fileName: 'plugins/save-scroll-position'
}, {
  el: '.dateselector',
  fileName: 'components/datepicker'
}, {
  el: '.slider-icon_group',
  fileName: 'components/slider-icon-group'
}, {
  el: '.slider-gallery',
  fileName: 'components/slider-gallery'
}, {
  el: '.focuspoint',
  fileName: 'components/hotspot'
}, {
  el: '.cards-carousel',
  fileName: 'components/cards-carousel'
}, {
  el: '.steps-carousel',
  fileName: 'components/steps-carousel'
}, {
  el: '.ce-slider_video',
  fileName: 'components/slider-video'
}, {
  el: '.ce-keyvisual',
  fileName: 'components/keyvisual'
}, {
  el: '.product-carousel',
  fileName: 'components/product-carousel'
}, {
  el: '.awards-carousel',
  fileName: 'components/awards'
}, {
  el: '.scroll-container',
  fileName: 'components/scroll-horizontal'
}, {
  el: '[data-toggle="collapse"]',
  fileName: 'components/news-filter'
}, {
  el: '.locations-list',
  fileName: 'components/locations-list'
}, {
  el: '.locations-map',
  fileName: 'components/locations-map'
}, {
  el: '[data-form-id][data-form-api-url], .ms-dynamic',
  fileName: 'components/ms-dynamic'
}, {
  el: '.js-video',
  fileName: 'components/video-player'
}, {
  el: '.powermail-form',
  fileName: 'components/powermail'
}, {
  el: '.results-list',
  fileName: 'components/product-list'
}, {
  el: '[data-toggle="toast"]',
  fileName: 'components/toast'
}, {
  el: 'a[data-download-gate]',
  fileName: 'components/download-gate'
}, {
  el: '[data-iframe-fullscreen]',
  fileName: 'components/iframe-fullscreen'
}];
export default components;